module.exports = __webpack_public_path__ + "img/Avatar-16.a2fc426c.gif";